export default __webpack_public_path__ + "static/media/AboutUs.23051dd3.jpeg";